import UlocCore, {IconMaterialWeb, IconFontAwesomeWeb} from 'uloc-vue'

export function createIcons () {
  UlocCore.IconLibrary.add([
    {
      name: 'fa',
      component: IconFontAwesomeWeb,
      type: 'web'
    },
    {
      name: 'default',
      component: IconMaterialWeb
    },
    {
      name: 'material',
      component: IconMaterialWeb
    }
  ])
}
